import React from 'react';

const Editable = React.createClass({

	getInitialState: function() {
		return {
      editing: false,
      lastValue: this.props.value,
      value: this.props.value
    }
	},

  componentWillReceiveProps: function(props) {
    if(this.state.value !== props.value) {
      this._updateState(this.state.editing, props.value, true);
    }
  },

	render: function() {
		let element;

		if(this.state.editing) {
			element = (
        <input 
  				type="text" 
          autoFocus
          className={this.props.className}
  				value={this.state.value}
  				onChange={this.handleChange}
  				onBlur={this.handleBlur}
  				onKeyDown={this.handleKeyDown}
  				style={this._createStyle()} />
      );
		}
		else {
			element = (
				<this.props.tagName
          className={this.props.className}
					onClick={this.handleClick}>{this.state.value || this.props.defaultText}
				</this.props.tagName>
			);
		}

    return element;
  },

  handleClick: function(e) {
  	this._updateState(!this.state.editing, this.state.value);
  },

  handleBlur: function(e) {
    this._updateState(false, this.state.value);
  },

  handleChange: function(e) {
  	this._updateState(this.state.editing, e.target.value);
  },

  handleKeyDown: function(e) {
  	if(e.which === 13) {
  		this._updateState(false, e.target.value);
  	}
  },

  _updateState: function(editing, value, silent) {
  	let lastValue = this.state.lastValue;

  	if(!silent && value && editing === false && lastValue !== value) {
  		lastValue = null;
  		if(this.props.onChange) {
  			this.props.onChange(this.state.lastValue, value, this.props.data);
  		}
  	}
    
    this.setState({
      editing: editing,
      lastValue: lastValue,
      value: value
    });
  },

  _createStyle: function() {
  	return {
  		padding: 0,
  		backgroundColor: 'transparent',
  		border: 0,
  		fontSize: 'inherit'
  	};
  }

});

export default Editable;


/** WEBPACK FOOTER **
 ** ./src/js/components/common/editable.js
 **/